import { createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

import * as actions from "./Actions";

const initialState = {
  isLoading: false,
  error: "",
  success: false,
  data: {},
};

const communitySlice = createSlice({
  name: "community",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //HYDRATE
      .addCase(HYDRATE, (state, { payload }) => ({
        ...state,
        ...payload.community,
      }))
      // GET HEALTH LANDING PAGE
      .addCase(actions.getCommunityThreadByID.pending, (state) => ({
        ...state,
        isLoading: true,
        success: false,
        error: "",
      }))
      .addCase(
        actions.getCommunityThreadByID.fulfilled,
        (state, { payload }) => {
          return {
            ...state,
            isLoading: false,
            success: true,
            data: payload?.data,
          };
        }
      )
      .addCase(
        actions.getCommunityThreadByID.rejected,
        (state, { payload }) => ({
          ...state,
          isLoading: false,
          error: payload,
        })
      );
  },
});

export { getCommunityThreadByID } from "./Actions";

export default communitySlice.reducer;
